
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinakola() {



const cardData = {
  keyword: 'Cab Service in Akola MIDC',
  heading: 'eTravo: Cab Service in Akola MIDC',
  headingDescription: `eTravo provides reliable and professional cab services in Akola MIDC, tailored to meet the evolving transportation needs of industries, corporate teams, and business professionals in this growing industrial zone. Whether it's routine employee pickups, executive transfers, or client transportation, our fleet of GPS-enabled, air-conditioned vehicles ensures a smooth, comfortable, and timely travel experience. Operated by experienced drivers trained in corporate etiquette, eTravo’s services are backed by flexible rental plans, real-time route optimization, and 24/7 customer support. For hassle-free corporate commuting and industrial mobility in Akola MIDC, eTravo stands as your trusted travel partner.`,

  top: 'Top Places to visit in Akola with eTravo',
   "topPlaces": [
    {
      "title": "Akola MIDC Industrial Area",
      "description": "Established in 1972, Akola MIDC Industrial Area is one of Maharashtra's oldest industrial estates, spanning over 281 hectares. It hosts a variety of industries, including agro-processing units, textile manufacturing, and engineering firms. eTravo offers tailored transportation solutions to ensure timely and efficient employee commutes, supporting shift operations and enhancing industrial productivity."
    },
    {
      "title": "Akola City Center",
      "description": "The commercial and administrative heart of Akola, featuring government offices, banks, and corporate establishments. eTravo's executive cab services facilitate seamless travel for business meetings and official engagements, ensuring punctuality and comfort."
    },
    {
      "title": "Akola Junction Railway Station",
      "description": "A crucial railway hub connecting Akola with major cities across India. eTravo offers convenient pickup and drop services, bridging the gap between rail travel and workplace commutes for employees and business travelers."
    },
    {
      "title": "Ridhora Logistics Hub",
      "description": "Ridhora is emerging as a significant logistics center in Akola, enhancing the region's warehousing and transportation capabilities. eTravo supports logistics personnel with scheduled and on-demand cab services, ensuring smooth operations and timely deliveries."
    },
    {
      "title": "Dr. Panjabrao Deshmukh Krishi Vidyapeeth",
      "description": "A premier agricultural university attracting students and faculty from various regions. eTravo offers reliable transportation solutions for daily commutes, academic events, and inter-campus travel, promoting educational excellence."
    },
    {
      "title": "Government Medical College, Akola",
      "description": "A key healthcare and educational institution in the region. eTravo provides dependable cab services for medical professionals, students, and patients, ensuring timely arrivals and departures for critical healthcare services."
    },
    {
      "title": "Akola Trade Center",
      "description": "A prominent commercial complex housing various businesses and offices. eTravo facilitates transportation for employees and clients, enhancing business operations with convenient and safe travel options."
    },
    {
      "title": "Kherde Hospital",
      "description": "A well-established private healthcare facility in Akola. eTravo offers reliable cab services for healthcare professionals and patients, ensuring timely arrivals and departures from hospitals and clinics."
    },
    {
      "title": "Akola Education Society",
      "description": "An educational organization overseeing a network of schools and colleges, providing education from kindergarten to postgraduate levels. eTravo provides transportation solutions for students and faculty members, ensuring safe and timely commutes."
    },
    {
      "title": "Siddhivinayak Hospital",
      "description": "A multi-specialty hospital serving the healthcare needs of Akola residents. eTravo offers reliable cab services for healthcare professionals and patients, ensuring timely arrivals and departures from hospitals and clinics."
    }
  ],

services: [
  {
    name: 'Akola MIDC Corporate Cab Rentals',
    description: `Specialized corporate cab rental plans tailored for businesses operating in Akola MIDC. Our service offers flexible rental durations, a diverse fleet of well-maintained vehicles, and dedicated customer support to ensure seamless business transportation and efficient logistics management.`
  },
  {
    name: 'Employee Transport Cab Akola MIDC',
    description: `Reliable and safe employee transport solutions aligned with shift timings for factories and offices in Akola MIDC. Our GPS-tracked vehicles, managed by a dedicated operations team, provide punctual and comfortable daily commutes, helping to enhance workforce productivity.`
  },
  {
    name: 'Business Cab Services Akola MIDC',
    description: `Efficient and flexible cab services catering to business executives and corporate staff traveling for meetings, client visits, and site inspections. Our drivers possess deep local knowledge, ensuring timely arrivals and comfortable journeys across Akola and neighboring areas.`
  },
  {
    name: 'Corporate Staff Cabs Akola MIDC',
    description: `Group transport services with smart multi-route planning and real-time GPS tracking. Ideal for corporate teams commuting together, this service reduces transportation costs, lowers traffic congestion, and ensures employee safety with coordinated batch pickups and drop-offs.`
  },
  {
    name: 'Reliable Corporate Cab Service Akola MIDC',
    description: `Committed to high standards of service quality, our corporate cabs feature clean, well-maintained vehicles and professional drivers. We emphasize punctuality, courteous service, and effective communication to meet the specific requirements of corporate clients in Akola MIDC.`
  },
  {
    name: 'AC Corporate Cabs Akola MIDC',
    description: `Comfort-driven air-conditioned cab services providing a cool and relaxing travel environment throughout the year. Suitable for daily employee commutes as well as executive rides, our AC fleet ensures a pleasant experience even during Akola’s hotter months.`
  },
  {
    name: 'Staff Pickup and Drop Cab Akola MIDC',
    description: `Comprehensive staff transportation covering multiple shifts including night schedules, with flexible timing options. Available 24/7, our experienced drivers ensure safe, timely pickups and drop-offs, keeping your workforce on schedule and secure.`
  },
  {
    name: 'Affordable Business Cab Rentals Akola MIDC',
    description: `Cost-efficient cab rental plans tailored for startups, SMEs, and large corporations. Transparent pricing models and scalable vehicle deployment allow businesses to optimize transport costs without compromising service quality or reliability.`
  },
  {
    name: 'Executive Cab Services Akola MIDC',
    description: `Premium executive transport featuring luxury vehicles and expert chauffeurs. Ideal for airport transfers, VIP client visits, and important business meetings, offering a discreet, comfortable, and professional travel experience for senior management.`
  },
  {
    name: 'Monthly Corporate Cab Rentals Akola MIDC',
    description: `Monthly fixed-route cab rental packages designed to simplify employee transport management and reduce administrative overhead. These plans ensure consistent service quality, streamlined billing, and smooth coordination with HR and admin teams.`
  },
  {
    name: 'Industrial Area Employee Transport Akola MIDC',
    description: `Optimized employee transport services tailored for industrial workers, focusing on safety, timeliness, and compliance with local industrial regulations. Our routing and scheduling systems ensure smooth travel between residential zones and work areas.`
  },
  {
    name: 'Corporate Client Cabs Akola MIDC',
    description: `Dedicated client transportation solutions that offer professional, comfortable, and punctual travel for visiting business guests. From airport pickups to corporate site visits, we help you leave a lasting positive impression.`
  },
  {
    name: 'Business Meeting Cabs Akola MIDC',
    description: `Rapid and reliable cab services designed for executives attending urgent or scheduled business meetings in Akola and surrounding regions. We provide easy booking, prompt dispatch, and professional service to keep your business moving efficiently.`
  },
  {
    name: 'Akola Industrial Area Cab Hire',
    description: `Flexible on-demand cab hire services throughout Akola’s industrial corridors for site inspections, logistics, and corporate errands. Our drivers have expert knowledge of the local industrial landscape, ensuring hassle-free, timely transport.`
  },
  {
    name: 'Corporate Shuttle Cabs Akola MIDC',
    description: `Group shuttle services using minibuses or large vans to transport employees during shift changes or corporate events. This service enhances operational efficiency, reduces environmental impact, and ensures coordinated team travel for bulk employee movement.`
  }
],

tableData: [
  ['Akola MIDC Corporate Cab Rentals', 'Employee Transport Cab Akola MIDC'],
  ['Business Cab Services Akola MIDC', 'Corporate Staff Cabs Akola MIDC'],
  ['Reliable Corporate Cab Service Akola MIDC', 'AC Corporate Cabs Akola MIDC'],
  ['Staff Pickup and Drop Cab Akola MIDC', 'Affordable Business Cab Rentals Akola MIDC'],
  ['Executive Cab Services Akola MIDC', 'Monthly Corporate Cab Rentals Akola MIDC'],
  ['Industrial Area Employee Transport Akola MIDC', 'Corporate Client Cabs Akola MIDC'],
  ['Business Meeting Cabs Akola MIDC', 'Akola Industrial Area Cab Hire'],
  ['Corporate Shuttle Cabs Akola MIDC', '']
],


"whychoose": [
  {
    "WhyChooseheading": "Tailored Cab Services for Akola MIDC",
    "WhyChoosedescription": "eTravo offers customized cab services specifically designed for businesses in Akola MIDC. Our solutions ensure timely and safe employee transportation, enhancing operational efficiency and workforce productivity."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Corporate Needs",
    "WhyChoosedescription": "Our fleet includes well-maintained sedans, SUVs, and multi-utility vehicles, providing flexible options for daily commutes, executive travel, or client visits, all focused on comfort and safety."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Knowledge",
    "WhyChoosedescription": "Our professional drivers have comprehensive knowledge of Akola MIDC’s roads and industrial layout, ensuring efficient navigation, punctual pickups, and a professional travel experience."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Match Shift Patterns",
    "WhyChoosedescription": "We provide flexible booking solutions including scheduled rides, on-demand cabs, and long-term contracts to accommodate the varied shift timings common in industrial sectors."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking for Safety and Transparency",
    "WhyChoosedescription": "All vehicles are equipped with GPS tracking for real-time monitoring, enhancing safety, accountability, and transparency for corporate clients."
  },
  {
    "WhyChooseheading": "Transparent Billing with Detailed Invoices",
    "WhyChoosedescription": "We offer clear and detailed billing with trip summaries and fare breakdowns, simplifying financial management and reimbursement processes."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Standards",
    "WhyChoosedescription": "Our fleet undergoes regular sanitization and maintenance, and drivers follow strict hygiene protocols to ensure a safe and healthy travel environment."
  },
  {
    "WhyChooseheading": "Dedicated Account Management Support",
    "WhyChoosedescription": "Each corporate client is assigned a dedicated account manager who manages bookings, promptly addresses queries, and ensures a smooth cab service experience in Akola MIDC."
  }
]









}

const faqData = [
  [
    {
      question: "Which areas do your Akola MIDC cab services cover?",
      answer: "Our cab services cover the entire Akola MIDC region and surrounding industrial areas, ensuring efficient transport for employees."
    },
    {
      question: "Can we arrange cab services for different shift timings?",
      answer: "Yes, we offer flexible scheduling to accommodate fixed, rotating, and night shifts."
    },
    {
      question: "Do you provide monthly consolidated billing for businesses?",
      answer: "Absolutely. Corporate clients receive monthly GST-compliant invoices with detailed trip summaries."
    },
    {
      question: "Are your drivers trained for industrial and corporate transport?",
      answer: "Yes, our drivers are trained in safety, professional etiquette, and have comprehensive knowledge of Akola MIDC routes."
    },
    {
      question: "What safety protocols are followed during rides?",
      answer: "We ensure safety with GPS tracking, regular vehicle sanitization, driver background checks, and 24/7 support."
    },
    {
      question: "Is dedicated corporate support available?",
      answer: "Yes, we assign dedicated account managers to provide priority support for all corporate clients."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Sunil Deshmukh",
    designation: "Operations Manager, Akola Textiles Ltd.",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s cab services have greatly enhanced our employees’ commute, offering reliability and professionalism every day.”"
  },
  {
    name: "Ms. Nisha Jadhav",
    designation: "HR Head, Akola Industrial Solutions",
    rating: [1, 1, 1, 1, 1],
    text: "“The professionalism and timely service from eTravo have been invaluable to our workforce transportation.”"
  }
];









































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Akola MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-akola-midc.jpg",
  "description": "Reliable corporate cab service in Akola MIDC offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-akola-midc"
  }
};





    return (
        <div>
<Helmet>
  <title>Cab Service in Akola MIDC | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Akola MIDC for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/89.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinakola;